import React from 'react';
import { Grid, Typography, Button, Box } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import LanguageIcon from '@mui/icons-material/Language';
import minilogo from '../assets/javasite/images/minilogo.png';
import contact from '../assets/Images5/contact.jpg';

export function ContactPage() {
  return (
    <Grid container justifyContent="center" spacing={1}>
      <Grid item xs={12} md={10} lg={8}>
        <div id="about1" className="isoitem about-tope">
          <div className="blackbox">
            <div id="minilogo"><img src={minilogo} width="196" height="158" alt="DraZtic Mini Logo" /></div>
            <div id="title4"><strong>Contact DRAZTIC.COM</strong></div>
            <div id="abouttext" flex="" className="flex">
              <Typography variant="body1" sx={{ mb: 3, color: '#fff' }}>
                I'm currently exploring new opportunities in UX Design and Front-End Development. If you're looking for a designer who thinks in systems and builds with code, I'd love to talk.
              </Typography>
              <Box sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap', justifyContent: 'center' }}>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<EmailIcon />}
                  href="mailto:draztic@draztic.com"
                  sx={{ color: '#000' }}
                >
                  Email Me
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  startIcon={<LanguageIcon />}
                  href="http://www.draztic.com"
                  target="_blank"
                >
                  draztic.com
                </Button>
              </Box>
            </div>
          </div>
        </div>
      </Grid>
    </Grid>
  );
}
